import React from 'react';
import { Box, Typography } from '@mui/material';
import styles from './NoTasksPage.module.css';
import noTasksImage from './img/noTasks.png'; // Placeholder image, replace with your actual image path

const NoTasksPage: React.FC = () => {
    return (
        <Box className={styles.noTasksContainer}>
            <Typography variant="h4" gutterBottom className={styles.title}>
                Заданий пока нет
            </Typography>
            <Typography variant="body1" align="center" className={styles.description}>
                Напишем тебе сюда и в ТГ-бот, как только получим задание, подходящее тебе по опыту и навыкам.
                <br />
                А пока проверь, все ли навыки ты указал? ;)
            </Typography>
            <img src={noTasksImage} alt="No tasks" className={styles.noTasksImage} />
        </Box>
    );
};

export default NoTasksPage;
